import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../contexts/StoreContext';
import useResponsiveScreen from '../../../../hooks/useResponsiveScreen';
import { TestIDs } from 'src/constants/testIDs.constants';
import { DynamicModalProps } from '../DynamicModal.types';
import BaseModal from '../../base-modal/BaseModal';
import { cleanIndexDB } from '@photosi/rn-components/global-error-boundary/error-views/no-available-space-error/NoAvailableSpaceError.utils';
import { useEffect } from 'react';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { DYNAMIC_MODAL_ACTIONS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';

export const ModalNoAvailableSpace = observer(
  ({ type, dynamicModalVisible, dynamicModalLayer: { id, actionCallback } }: DynamicModalProps) => {
    const { i18n } = useStore();
    const { isMobile } = useResponsiveScreen();

    useEffect(() => {
      cleanIndexDB();
    }, []);

    return (
      <BaseModal
        modalStyle={{ minHeight: 300 }}
        testID={TestIDs.NO_AVAILABLE_SPACE}
        modalIcon={
          <Illustration name={ILLUSTRATION_NAMES.Alert} width={isMobile ? 54 : 64} height={isMobile ? 54 : 64} />
        }
        title={i18n.t('modal-no-available-space:title')}
        description={i18n.t('modal-no-available-space:description')}
        confirmText={i18n.t('modal-no-available-space:cta')}
        handleConfirm={() => {
          actionCallback(DYNAMIC_MODAL_ACTIONS.CONTINUE);
        }}
        isVisible={dynamicModalVisible}
        closeOnClickOutside={false}
        type={type}
        id={id ?? 'no-available-space-error'}
        modalWidth={460}
      ></BaseModal>
    );
  },
);
